/*
 Created by qing on 2020/10/6
 Des:
 */
import BaseItem from '../BaseItem'
import {
  BUTTON_TYPE_PLUGIN,
  DATA_TYPE__BUTTON,
  FORM_ITEM__BUTTON
} from "../types"

class Button extends BaseItem {
  constructor() {
    super()

    this.value = ''

    this.buttonName = '按钮'
    this.buttonType = BUTTON_TYPE_PLUGIN // PLUGIN 插件 FORM 弹出表单
    this.applyAppId = ''
    this.applyFormId = ''
    this.buttonColor = '#2196F3'
    this.showAlert = 0 // 是否显示弹窗 0 否 1 是
    this.iconType = 'success'
    this.showTitle = '提示' // 显示标题
    this.alertText = '' // 弹窗文字内容
    this.confirmText = '确认' // 确认按钮文字
    this.cancelText = '取消' // 取消按钮文字

    this.createMap = [
      // {
      //   inputType: 1, // 0 具体的值 1 表单字段 2 当前时间 3 相对时间 4 清空内容
      //   inputValue: "", // 填写的具体的值 定时任务的时候 全部为此种类型
      //   relateType: -1, // -1 之前 1 之后
      //   days: 1, // 几天
      //   localFieldId: "",
      //   remoteFieldId: "",
      //   key: this.$RyUuid()
      // }
    ]
    this.buttonShowStyle = "CLASSICS" //显示样式 CLASSICS 经典  CARD 卡片  DIAL 宫格
    this.customConfigInfo = {
      title: '',
      des: '',

      iconType: 'system', // system  custom
      icon: '',
      iconBgColor: '',
      iconUrl: ''
    } //自定义设置,前端存放内容,后端不解析
  }

  get title() {
    return this.fieldTitle || Button._title
  }

  set title(val) {
    this.fieldTitle = val
  }
}

Button._title = '按钮'
Button.type = FORM_ITEM__BUTTON
Button.use = true
Button.prototype.icon = 'iconfont icon-button'

Button.prototype.type = Button.type
Button.prototype.dataType = DATA_TYPE__BUTTON
Button.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    buttonName: this.buttonName,
    buttonType: this.buttonType,
    applyAppId: this.applyAppId,
    applyFormId: this.applyFormId,
    buttonColor: this.buttonColor,
    showAlert: this.showAlert,
    iconType: this.iconType,
    alertText: this.alertText,
    confirmText: this.confirmText,
    cancelText: this.cancelText,
    showTitle: this.showTitle,
    createMap: this.createMap,
    buttonShowStyle: this.buttonShowStyle,
    customConfigInfo: this.customConfigInfo
  }
}
Button.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts) {
    this.buttonName = opts.buttonName
    this.buttonType = opts.buttonType || BUTTON_TYPE_PLUGIN
    this.applyAppId = opts.applyAppId
    this.applyFormId = opts.applyFormId
    this.buttonColor = opts.buttonColor
    this.showAlert = opts.showAlert
    this.iconType = opts.iconType
    this.alertText = opts.alertText
    this.confirmText = opts.confirmText
    this.cancelText = opts.cancelText
    this.showTitle = opts.showTitle
    this.createMap = opts.createMap || []
    if (opts.buttonShowStyle) this.buttonShowStyle = opts.buttonShowStyle
    if(opts.customConfigInfo) this.customConfigInfo = opts.customConfigInfo
  }
}
Button.prototype.getValue = function () {
  return this.value
}
Button.prototype.setValue = function (val) {
  this.value = val || ''
}
Button.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}
Button.prototype.colorOpts = [
  '#2196F3',
  '#E91E63',
  '#FF9800',
  '#4CAF50',
  '#00BCD4',
  '#3F51B5',
  '#455A64',
  '#63B2EE',
  '#76DA91',
  '#F8CB7F',
  '#7CD6CF',
  '#9192AB',
  '#7898E1',
  '#EFA666',
  '#9987CE'
]
export default Button
